<template>
  <div class="columns has-bg-light" v-if="a">
    <div class="column is-12">
      <div class="notification has-bg-annonce is-radius-large is-paddingless">
        <div class="columns is-gapless is-padding-small">
          <div class="column is-11 is-paddingless">
            <p class="title is-size-3 has-text-white"><strong>{{a.title}}</strong></p>
            <p class="has-text-white">{{a.description}}</p>
            <a :href="a.link" target="_blank" v-if="a.link" class="button is-white is-outlined is-margin-top">Voir</a>
          </div>
          <div class="column is-self-centered has-text-right">
            <button @click="close" class="button is-circle is-outlined is-white">
              <span class="icon"><i class="fal fa-times"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'EventNotification',
    computed: {
      ...mapGetters(['lastAnnouncement']),
      a () {
        return this.lastAnnouncement
      }
    },
    methods: {
      close () {
        const pk = this.lastAnnouncement.pk
        this.$api.eventService.patch(pk, {is_new: false}).then(r => {
          this.$store.commit('editEvent', {data: r.data})
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/event/EventNotification.vue